import { useEffect, useState } from "react";
import userStore from "../../../zustand/userStore";
import axios from "../api/axios";
import {
  formatDuration,
  formatDurationNew,
  formatText,
  formatText1,
} from "../../Quiz-app/utilss/utils";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import img1 from "../../Quiz-app/images/img.png";
import logo from "../../Quiz-app/images/docmaster.png";
import img02 from "../../Quiz-app/images/about.png";
import img3 from "../../Quiz-app/images/terms-and-conditions.png";
import TermsAndConditions2 from "./TermsAndConditions2";

export default function StudentQuizPage() {
  const userData = userStore((state) => state.user);
  const [activeTab, setActiveTab] = useState("live");
  const [quizzes, setQuizzes] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();

  const quizMode = location.state?.quizMode;

  const [successMessage, setSuccessMessage] = useState("");
  const [successType, setSuccessType] = useState("");
  const [selectedQuiz, setSelectedQuiz] = useState([]);
  const [open, setOpen] = useState(false);
  const [list, setList] = useState([]);
  const [quiz, setQuiz] = useState("");
  const [classList, setClassList] = useState([]);
  const [selectedClass, setSelectedClass] = useState("");
  const [showClassSelect, setShowClassSelect] = useState(false);
  const [groupList, setGroupList] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState("");

  // New state for expanded modules
  const [expandedModuleSubjectiveLive, setExpandedModuleSubjectiveLive] =
    useState(null);
  const [
    expandedModuleSubjectivePractice,
    setExpandedModuleSubjectivePractice,
  ] = useState(null);
  const [expandedModuleThematicLive, setExpandedModuleThematicLive] =
    useState(null);
  const [expandedModuleThematicPractice, setExpandedModuleThematicPractice] =
    useState(null);

  const [data, setData] = useState({
    selectedQuiz: null,
    openPopUp: false,
  });

  // Inline Styles for new UI
  const styles = {
    mainContainer: {
      background: "#f9fafb",
      minHeight: "100vh",
    },
    rightCol: {
      padding: "20px",
    },
    row: {
      marginTop: "20px",
    },
    col: {
      padding: "0 12px",
    },
    quizSectionCard: {
      background: "#ffffff",
      borderRadius: "8px",
      padding: "30px 25px",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
      height: "100%",
      marginBottom: "20px",
    },
    quizSectionTitle: {
      fontSize: "28px",
      fontWeight: "700",
      color: "#1a1a1a",
      marginBottom: "8px",
    },
    quizSectionSubtitle: {
      fontSize: "15px",
      color: "#6b7280",
      marginBottom: "25px",
    },
    quizModulesContainer: {
      display: "flex",
      flexDirection: "column",
      gap: "12px",
    },
    quizModuleItem: {
      background: "#ffffff",
      borderRadius: "8px",
      cursor: "pointer",
      transition: "all 0.3s ease",
      overflow: "hidden",
    },
    quizModuleItemExpanded: {
      background: "#ffffff",
      border: "2px solid #86efac",
      borderRadius: "8px",
      cursor: "pointer",
      transition: "all 0.3s ease",
      overflow: "hidden",
    },
    quizModuleItemHover: {
      background: "#ffffff",
      borderRadius: "8px",
      cursor: "pointer",
      transition: "all 0.3s ease",
      overflow: "hidden",
    },
    moduleHeader: {
      padding: "20px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      background: "linear-gradient(135deg, #dcfce7 0%, #bbf7d0 100%)",
      border: "2px solid #86efac",
      borderRadius: "8px",
      transition: "background 0.3s ease",
    },
    moduleHeaderExpanded: {
      padding: "20px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      background: "linear-gradient(135deg, #dcfce7 0%, #bbf7d0 100%)",
      border: "2px solid #86efac",
      borderRadius: "8px 8px 0 0",
      transition: "background 0.3s ease",
    },
    moduleHeaderHover: {
      padding: "20px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      background: "linear-gradient(135deg, #bbf7d0 0%, #86efac 100%)",
      border: "2px solid #86efac",
      borderRadius: "8px",
      transition: "background 0.3s ease",
    },
    moduleIcon: {
      fontSize: "24px",
      color: "#166534",
      marginRight: "15px",
      transition: "color 0.3s ease",
    },
    moduleIconWhite: {
      fontSize: "24px",
      color: "#166534",
      marginRight: "15px",
      transition: "color 0.3s ease",
    },
    chevronIcon: {
      color: "#131415ff",
      fontSize: "14px",
      transition: "transform 0.3s ease, color 0.3s ease",
    },
    chevronIconWhite: {
      color: "#ffffff",
      fontSize: "14px",
      transition: "transform 0.3s ease, color 0.3s ease",
    },
    chevronIconRotated: {
      color: "#131415ff",
      fontSize: "14px",
      transform: "rotate(180deg)",
      transition: "transform 0.3s ease, color 0.3s ease",
    },
    chevronIconRotatedWhite: {
      color: "#ffffff",
      fontSize: "14px",
      transform: "rotate(180deg)",
      transition: "transform 0.3s ease, color 0.3s ease",
    },
    moduleTitle: {
      fontSize: "16px",
      fontWeight: "600",
      color: "#166534",
      marginBottom: "2px",
      transition: "color 0.3s ease",
    },
    moduleTitleWhite: {
      fontSize: "16px",
      fontWeight: "600",
      color: "#166534",
      marginBottom: "2px",
      transition: "color 0.3s ease",
    },
    moduleSubtitle: {
      fontSize: "13px",
      color: "#15803d",
      transition: "color 0.3s ease",
    },
    moduleSubtitleWhite: {
      fontSize: "13px",
      color: "#15803d",
      transition: "color 0.3s ease",
    },
    dFlex: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
    },
    dFlexCenter: {
      display: "flex",
      alignItems: "center",
    },
    dropdownContent: {
      padding: "8px 16px 16px 16px",
      display: "flex",
      flexDirection: "column",
      gap: "12px",
    },
    quizCard: {
      background: "#ffffff",
      border: "1px solid #e5e7eb",
      borderRadius: "8px",
      padding: "16px",
      boxShadow: "0 1px 3px rgba(0, 0, 0, 0.05)",
    },
    quizCardHeader: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "flex-start",
      marginBottom: "12px",
    },
    quizTitle: {
      fontSize: "16px",
      fontWeight: "600",
      color: "#1f2937",
      margin: "0",
    },
    liveBadge: {
      background: "#fee2e2",
      color: "#dc2626",
      padding: "4px 12px",
      borderRadius: "4px",
      fontSize: "11px",
      fontWeight: "600",
      letterSpacing: "0.5px",
    },
    quizMeta: {
      display: "flex",
      alignItems: "center",
      gap: "16px",
      marginBottom: "12px",
      color: "#6b7280",
      fontSize: "14px",
    },
    metaItem: {
      display: "flex",
      alignItems: "center",
      gap: "6px",
    },
    playButton: {
      background: "#2563eb",
      color: "#ffffff",
      border: "none",
      borderRadius: "6px",
      padding: "12px",
      width: "100%",
      fontWeight: "600",
      fontSize: "15px",
      cursor: "pointer",
      transition: "all 0.3s ease",
    },
    columnHeader: {
      background: "#f3f4f6",
      padding: "12px 16px",
      borderRadius: "6px 6px 0 0",
      textAlign: "center",
      marginBottom: "12px",
      borderBottom: "2px solid #2563eb",
    },
    columnHeaderText: {
      color: "#2563eb",
      fontWeight: "600",
      fontSize: "13px",
      letterSpacing: "0.5px",
    },
    infoBox: {
      background: "#f9fafb",
      borderRadius: "8px",
      padding: "20px",
      color: "#374151",
      marginTop: "20px",
      boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
    },
    infoLabel: {
      fontSize: "14px",
      fontWeight: "600",
      color: "#6b7280",
      minWidth: "120px",
    },
    infoValue: {
      fontSize: "14px",
      color: "#1f2937",
      fontWeight: "500",
      textAlign: "right",
      flex: 1,
    },
  };

  const getList = async () => {
    try {
      const quizRes = await axios.get("/participant/top-participants");
      setList(quizRes.data.leaderboard);
      setQuiz(quizRes.data?.quiz_name);
    } catch (err) {
      console.error("Error fetching quiz data:", err);
    }
  };

  const fetchAll = async () => {
    try {
      console.log(userData, "yuser data");
      const quizRes = await axios.get(`/all-quizzes?userId=${userData.id}`);
      setQuizzes(quizRes.data);

      const classEntries = quizRes.data.flatMap((quiz) =>
        (quiz.class_id || []).flatMap((cls) => {
          const ids = Array.isArray(cls.class_id)
            ? cls.class_id
            : [cls.class_id];
          const name = cls.class_name || `Class ${ids[0] || "-"}`;
          return ids.map((id) => ({ id, name }));
        }),
      );

      const uniqueClasses = Array.from(
        new Map(classEntries.map((c) => [c.id, c])).values(),
      );
      setClassList(uniqueClasses);

      const groupEntries = quizRes.data.flatMap((quiz) => {
        if (Array.isArray(quiz.group_id)) {
          return quiz.group_id.map((grp) => ({
            id: grp.group_id,
            name: grp.group_name || `Group ${grp.group_id}`,
          }));
        }
        return [];
      });

      const uniqueGroups = Array.from(
        new Map(groupEntries.map((g) => [g.id, g])).values(),
      );
      setGroupList(uniqueGroups);
      console.log("ggroupList:", uniqueGroups);
    } catch (err) {
      console.error("Error fetching quiz data:", err);
    }
  };

  useEffect(() => {
    fetchAll();
  }, []);

  // Group by quiz_type
  const liveQuizzes = quizzes.filter((q) => q.quiz_type === 1);
  const practiceQuizzes = quizzes.filter((q) => q.quiz_type === 2);
  const thematicQuizzes = quizzes.filter((q) => q.quiz_type === 3);
  const practicethematicQuizzes = quizzes.filter((q) => q.quiz_type === 4);

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const d = new Date(dateString);
    return d
      .toLocaleString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      })
      .replace(",", " at");
  };

  function formatTerms(text, quizDetails) {
    if (!text) return "";
    let replaced = text
      .replace(/\[Number\]/g, quizDetails?.total_questions)
      .replace(
        /\[X seconds\]/g,
        quizDetails.total_questions * quizDetails.duration_per_question,
      )
      .replace(/\[X second\]/g, quizDetails.duration_per_question)
      .replace(/\[Correct\]/g, quizDetails.correct);

    const lines = replaced.split("\n").filter((l) => l.trim() !== "");
    let html = "<ol>";
    let inSubList = false;

    lines.forEach((line, idx) => {
      const trimmed = line.trim();
      if (idx === 0 && !/^\d+\./.test(trimmed)) {
        html = `<h3>${trimmed}</h3><ol>`;
        return;
      }

      if (/^\d+\./.test(trimmed)) {
        if (inSubList) {
          html += "</ul>";
          inSubList = false;
        }
        const withoutNum = trimmed.replace(/^\d+\.\s*/, "");
        html += `<li><strong>${withoutNum}</strong><ul>`;
        inSubList = true;
      } else {
        if (inSubList) {
          html += `<li>${trimmed}</li>`;
        } else {
          html += `<p>${trimmed}</p>`;
        }
      }
    });

    if (inSubList) html += "</ul>";
    html += "</ol>";
    return html;
  }

  function convertTermsToHtml(text, quizDetails) {
    if (!text) return "";
    let replaced = text
      .replace(/\[Number\]/g, quizDetails?.total_questions ?? "")
      .replace(
        /\[X seconds\]/g,
        quizDetails?.total_questions && quizDetails?.duration_per_question
          ? quizDetails.total_questions * quizDetails.duration_per_question
          : "",
      )
      .replace(/\[X second\]/g, quizDetails?.duration_per_question ?? "")
      .replace(
        /\[Correct\]/g,
        `${quizDetails?.marks_per_question} mark(s)` ?? "",
      );

    replaced = replaced.replace(/\*([^*\n]+?)\*/g, "<strong>$1</strong>");
    replaced = replaced.replace(/\r?\n/g, "<br/>");
    return replaced;
  }

  const handlePractice = (id, type, selectedId = null) => {
    setData((prev) => ({
      ...prev,
      selectedQuiz: null,
      openPopUp: false,
    }));

    if (type === 2 || type === 3 || type === 4) {
      const stateData = {
        quizType: type,
        quiz_id: id,
        ...(type === 2 && selectedId && { class_id: selectedId }),
        ...(type === 4 && selectedId && { group_id: selectedId }),
      };

      navigate(`/quiz-dashboard/startQuiz/${id}`, { state: stateData });
    }
  };

  function formatUTCToIST(input) {
    const date = new Date(input);

    const options = {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    };

    const parts = date.toLocaleString("en-GB", options).replace(",", "");
    // en-GB gives dd/mm/yyyy by default

    // Convert "11/12/2025 10:35 am" → "11/12/2025 at 10:35 AM"
    const [d, t, a] = parts.split(" ");
    return `${d} at ${t} ${a.toUpperCase()}`;
  }
  const handleRegistration = async () => {
    console.log("userData", userData);

    const rawStudentDetails = userData?.student_details;
    let studentDetails = null;

    if (rawStudentDetails && typeof rawStudentDetails === "object") {
      // Already an object (API/store gave us parsed data already) — use as-is.
      studentDetails = rawStudentDetails;
    } else if (typeof rawStudentDetails === "string") {
      try {
        studentDetails = JSON.parse(rawStudentDetails);
      } catch (err) {
        console.error(
          "Failed to parse student_details:",
          err,
          "raw value:",
          rawStudentDetails,
        );
        // Fallback: salvage just the first JSON object in the string, in case
        // something got concatenated/appended after it (this is what caused
        // the "Unexpected non-whitespace character after JSON" crash).
        const match = rawStudentDetails.match(/\{[\s\S]*?\}/);
        if (match) {
          try {
            studentDetails = JSON.parse(match[0]);
          } catch (err2) {
            console.error("Fallback parse also failed:", err2);
          }
        }
      }
    }

    if (!studentDetails) {
      alert(
        "Unable to read your student details. Please log out and log back in, then try again.",
      );
      return;
    }

    const { student_class } = studentDetails;
    // alert(data.selectedQuiz?.quiz_type);
    if (data.selectedQuiz?.quiz_type === 1) {
      console.log(
        "data.selectedQuiz.class_id",
        JSON.stringify(data.selectedQuiz.class_id),
      );
      console.log("student_class", student_class);
      const classIds = data.selectedQuiz.class_id?.map((c) => c.class_id) || [];
      if (classIds.includes(Number(student_class))) {
        const confirm = window.confirm("Are you sure to register this quiz?");
        if (confirm) {
          try {
            await axios.post(
              `/register-quiz?userId=${userData.id}&quiz_id=${data.selectedQuiz.id}&quiz_type=${data.selectedQuiz.quiz_type}`,
              {
                quiz_id: data.selectedQuiz.id,
              },
            );

            await fetchAll();
            setSuccessType("Registration Successul");
            setSuccessMessage(
              `You have successfully registered for the quiz. The quiz will start on <strong> ${formatUTCToIST(
                data.selectedQuiz?.start_date,
              )} </strong>. Please login 10 minutes before the start time to avoid any inconvenience. A registration code will be sent to your registered email, which you will need to join the quiz. In case of any query, please contact us on +91 9829440048.`,
            );
            setData((prev) => ({
              ...prev,
              selectedQuiz: null,
              openPopUp: false,
            }));
          } catch (err) {
            alert(err.response?.data?.message || "Registration failed");
          }
        }
      } else {
        alert(
          `You are not eligible to participate for this quiz. The quiz is for the ${
            data.selectedQuiz?.class_id
              ? data.selectedQuiz.class_id.map((e) => e.class_name).join(", ")
              : "-"
          }`,
        );
        setData((prev) => ({
          ...prev,
          selectedQuiz: null,
          openPopUp: false,
        }));
      }
    }
    if (data.selectedQuiz?.quiz_type === 3) {
      const classIds = data.selectedQuiz.group_id[0]?.class_ids || [];
      if (classIds.includes(Number(student_class))) {
        const confirm = window.confirm("Are you sure to register this quiz?");
        if (confirm) {
          try {
            await axios.post(
              `/register-quiz?userId=${userData.id}&quiz_id=${data.selectedQuiz.id}&quiz_type=${data.selectedQuiz.quiz_type}`,
              {
                quiz_id: data.selectedQuiz.id,
              },
            );

            await fetchAll();
            setSuccessType("Registration Successul");
            setSuccessMessage(
              `You have successfully registered for the quiz. The quiz will start on<strong> ${new Date(
                data.selectedQuiz?.start_date,
              ).toLocaleString()} </strong>. Please login 10 minutes before the start time to avoid any inconvenience. A registration code will be sent to your registered email, which you will need to join the quiz. In case of any query, please contact us on +91 9829440048.`,
            );
            setData((prev) => ({
              ...prev,
              selectedQuiz: null,
              openPopUp: false,
            }));
          } catch (err) {
            alert(err.response?.data?.message || "Registration failed");
          }
        }
      } else {
        alert(
          `You are not eligible to participate for this quiz, because u dont belong to ${data.selectedQuiz.group_id[0]?.group_name}`,
        );
        setData((prev) => ({
          ...prev,
          selectedQuiz: null,
          openPopUp: false,
        }));
      }
    }
    // if(data.selectedQuiz.quiz_type==1){
    //   if(student_class ===)
    // }
  };

  // New function to organize quizzes by modules/categories
  const organizeQuizzesByModule = (quizzesArray, quizType) => {
    const modules = {};

    quizzesArray.forEach((quiz) => {
      const category = quiz.category || quiz.subject || "General";
      if (!modules[category]) {
        modules[category] = {
          id: category.toLowerCase().replace(/\s+/g, "-"),
          title: category,
          subtitle: `${quizType} quiz modules`,
          quizzes: [],
        };
      }

      modules[category].quizzes.push({
        ...quiz,
        isLive: quizType === "LIVE",
        duration: formatDuration(
          quiz.total_questions * quiz.duration_per_question,
        ),
        questions: quiz.total_questions,
        description: quiz.about_quiz || "Test your knowledge with this quiz",
      });
    });

    return Object.values(modules);
  };

  // Organize quizzes into modules
  const subjectiveLiveModules = organizeQuizzesByModule(liveQuizzes, "LIVE");
  const subjectivePracticeModules = organizeQuizzesByModule(
    practiceQuizzes,
    "PRACTICE",
  );
  const thematicLiveModules = organizeQuizzesByModule(thematicQuizzes, "LIVE");
  const thematicPracticeModules = organizeQuizzesByModule(
    practicethematicQuizzes,
    "PRACTICE",
  );

  // Module Card Component
  const ModuleCard = ({
    module,
    expandedModule,
    setExpandedModule,
    quizType,
  }) => {
    const [isHovered, setIsHovered] = useState(false);
    const isExpanded = expandedModule === module.id;

    const toggleModule = () => {
      setExpandedModule(expandedModule === module.id ? null : module.id);
    };

    // Determine card style
    let cardStyle = styles.quizModuleItem;
    if (isHovered && !isExpanded) {
      cardStyle = styles.quizModuleItemHover;
    } else if (isExpanded) {
      cardStyle = styles.quizModuleItemExpanded;
    }

    // Determine header style
    let headerStyle = styles.moduleHeader;
    if (isExpanded) {
      headerStyle = styles.moduleHeaderExpanded;
    } else if (isHovered) {
      headerStyle = styles.moduleHeaderHover;
    }

    // Determine if text should be white
    const shouldBeWhite = isHovered || isExpanded;

    const handleQuizAction = (quiz) => {
      const now = new Date();
      const regStart = new Date(quiz.registration_start_date);
      const regEnd = new Date(quiz.registration_end_date);
      const registeredStatus = quiz.registered_status ?? 0;

      console.log("DEBUG", {
        quizType,
        registered_status: registeredStatus,
        now,
        regStart,
        regEnd,
      });

      // Practice quizzes (type 2 and 4)
      if (quizType === "PRACTICE") {
        setData((prev) => ({
          ...prev,
          selectedQuiz: { ...quiz, registered_status: 1 },
          openPopUp: true,
        }));
        if (quiz.quiz_type === 2) {
          setShowClassSelect(true);
          setSelectedClass("");
        } else if (quiz.quiz_type === 4) {
          setSelectedGroup("");
        }
      }
      // Live quizzes (type 1 and 3)
      else if (quizType === "LIVE") {
        if (registeredStatus === 0 && now >= regStart && now <= regEnd) {
          setData((prev) => ({
            ...prev,
            selectedQuiz: { ...quiz, registered_status: 1 },
            openPopUp: true,
          }));
        } else if (registeredStatus === 1) {
          setSuccessMessage(
            "You have already registered for the quiz. Please navigate to the Registered Quiz tab to participate.",
          );
        } else if (registeredStatus === 0 && now > regEnd) {
          setSuccessMessage(
            "Registration for the quiz has closed. Please try again for the next quiz.",
          );
        }
      }

      setSuccessType("");
    };

    useEffect(() => {
      if (quizzes.length === 0) return;

      if (quizMode === "practice") {
        if (subjectivePracticeModules.length > 0) {
          setExpandedModuleSubjectivePractice(subjectivePracticeModules[0].id);
        }

        if (thematicPracticeModules.length > 0) {
          setExpandedModuleThematicPractice(thematicPracticeModules[0].id);
        }

        // Close live modules
        setExpandedModuleSubjectiveLive(null);
        setExpandedModuleThematicLive(null);
      }

      if (quizMode === "live") {
        if (subjectiveLiveModules.length > 0) {
          setExpandedModuleSubjectiveLive(subjectiveLiveModules[0].id);
        }

        if (thematicLiveModules.length > 0) {
          setExpandedModuleThematicLive(thematicLiveModules[0].id);
        }

        // Close practice modules
        setExpandedModuleSubjectivePractice(null);
        setExpandedModuleThematicPractice(null);
      }
    }, [
      quizMode,
      quizzes.length,
      subjectivePracticeModules,
      thematicPracticeModules,
      subjectiveLiveModules,
      thematicLiveModules,
    ]);

    return (
      <div
        style={cardStyle}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <div style={headerStyle} onClick={toggleModule}>
          <div style={styles.dFlexCenter}>
            <div
              style={{
                background: "#22c55e",
                borderRadius: "8px",
                padding: "10px",
                marginRight: "15px",
              }}
            >
              <i
                className="fas fa-book"
                style={{
                  fontSize: "20px",
                  color: "#ffffff",
                }}
              ></i>
            </div>
            <div>
              <h5 style={styles.moduleTitle}>{module.title}</h5>
              <small style={styles.moduleSubtitle}>{module.subtitle}</small>
            </div>
          </div>
          <i
            className="fas fa-chevron-down"
            style={isExpanded ? styles.chevronIconRotated : styles.chevronIcon}
          ></i>
        </div>

        {isExpanded && (
          <div style={styles.dropdownContent}>
            {module.quizzes.map((quiz, quizIndex) => (
              <div key={quizIndex} style={styles.quizCard}>
                <div style={styles.quizCardHeader}>
                  <h6 style={styles.quizTitle}>{quiz.title}</h6>
                  {quiz.isLive && <span style={styles.liveBadge}>LIVE</span>}
                </div>

                <div style={styles.quizMeta}>
                  <div style={styles.metaItem}>
                    <i className="far fa-clock"></i>
                    <span>{quiz.duration}</span>
                  </div>
                  <div style={styles.metaItem}>
                    <i className="far fa-file-alt"></i>
                    <span>{quiz.questions} questions</span>
                  </div>
                </div>

                <button
                  style={styles.playButton}
                  onClick={() => handleQuizAction(quiz)}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = "#1d4ed8";
                    e.currentTarget.style.transform = "translateY(-1px)";
                    e.currentTarget.style.boxShadow =
                      "0 4px 12px rgba(37, 99, 235, 0.3)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = "#2563eb";
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow = "none";
                  }}
                >
                  {quizType === "PRACTICE"
                    ? "Play Now"
                    : quiz.registered_status === 1
                      ? "Registered"
                      : "Register Now"}
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    );
  };

  const renderModules = (
    modules,
    expandedModule,
    setExpandedModule,
    quizType,
  ) => {
    if (modules.length === 0) {
      // Different colors for LIVE vs PRACTICE
      const isLive = quizType === "LIVE";

      return (
        <div
          style={{
            background: isLive
              ? "linear-gradient(135deg, #e0f2fe 0%, #bae6fd 100%)"
              : "linear-gradient(135deg, #dcfce7 0%, #bbf7d0 100%)",
            border: isLive ? "2px solid #7dd3fc" : "2px solid #86efac",
            borderRadius: "8px",
            padding: "20px",
            display: "flex",
            alignItems: "center",
          }}
        >
          <div
            style={{
              background: isLive ? "#0ea5e9" : "#22c55e",
              borderRadius: "8px",
              padding: "10px",
              marginRight: "15px",
            }}
          >
            <i
              className={isLive ? "fas fa-calendar-times" : "fas fa-book-open"}
              style={{
                fontSize: "20px",
                color: "#ffffff",
              }}
            ></i>
          </div>
          <div>
            <h5
              style={{
                fontSize: "15px",
                fontWeight: "600",
                color: isLive ? "#0c4a6e" : "#166534",
                margin: "0 0 4px 0",
              }}
            >
              No Quiz Available
            </h5>
            <small
              style={{
                fontSize: "12px",
                color: isLive ? "#0369a1" : "#15803d",
              }}
            >
              No {quizType.toLowerCase()} quiz found
            </small>
          </div>
        </div>
      );
    }

    return modules.map((module, index) => (
      <ModuleCard
        key={index}
        module={module}
        expandedModule={expandedModule}
        setExpandedModule={setExpandedModule}
        quizType={quizType}
      />
    ));
  };

  // helper function (put inside your component)
  const getThemeDisplay = (theme) => {
    if (!theme) return "-";

    // case: already an array of theme objects
    if (Array.isArray(theme)) {
      return theme.map((t) => t?.theme_name ?? String(t)).join(", ");
    }

    // case: theme is an object like { theme_id: ["1"], theme_name: "1" }
    if (typeof theme === "object") {
      // if theme_name is array -> join
      if (Array.isArray(theme.theme_name)) return theme.theme_name.join(", ");
      // if theme_name is a string -> show it
      if (
        typeof theme.theme_name === "string" &&
        theme.theme_name.trim() !== ""
      )
        return theme.theme_name;
      // fallback: if theme_id is an array of ids, show those
      if (Array.isArray(theme.theme_id)) return theme.theme_id.join(", ");
      // lastly, join any remaining object values
      const vals = Object.values(theme).filter((v) => v != null && v !== "");
      return vals.length ? vals.join(", ") : "-";
    }

    // anything else (string/number)
    return String(theme);
  };

  return (
    <div style={styles.mainContainer}>
      <div style={styles.rightCol} role="main">
        {/* Quiz Type Selection Section */}
        <div style={styles.row} className="row">
          {/* Subjective Quizzes Section */}
          <div className="col-md-6" style={styles.col}>
            <div style={styles.quizSectionCard}>
              <h2 style={styles.quizSectionTitle}>Subjective Quizzes</h2>
              <p style={styles.quizSectionSubtitle}>
                Test your knowledge with in-depth questions
              </p>
              {/* <CompletionPopUp /> */}
              {/* Subjective Quiz Content - Side by Side */}
              <div style={{ display: "flex", gap: "20px" }}>
                {/* Live Quiz Column */}
                <div style={{ flex: 1 }}>
                  <div style={styles.columnHeader}>
                    <span style={styles.columnHeaderText}>LIVE QUIZ</span>
                  </div>
                  <div style={styles.quizModulesContainer}>
                    {renderModules(
                      subjectiveLiveModules,
                      expandedModuleSubjectiveLive,
                      setExpandedModuleSubjectiveLive,
                      "LIVE",
                    )}
                  </div>
                </div>

                {/* Practice Quiz Column */}
                <div style={{ flex: 1 }}>
                  <div style={styles.columnHeader}>
                    <span style={styles.columnHeaderText}>PRACTICE QUIZ</span>
                  </div>
                  <div style={styles.quizModulesContainer}>
                    {renderModules(
                      subjectivePracticeModules,
                      expandedModuleSubjectivePractice,
                      setExpandedModuleSubjectivePractice,
                      "PRACTICE",
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Thematic Quizzes Section */}
          <div className="col-md-6" style={styles.col}>
            <div style={styles.quizSectionCard}>
              <h2 style={styles.quizSectionTitle}>Thematic Quizzes</h2>
              <p style={styles.quizSectionSubtitle}>
                Test your knowledge with thematic questions
              </p>

              {/* Thematic Quiz Content - Side by Side */}
              <div style={{ display: "flex", gap: "20px" }}>
                {/* Live Quiz Column */}
                <div style={{ flex: 1 }}>
                  <div style={styles.columnHeader}>
                    <span style={styles.columnHeaderText}>LIVE QUIZ</span>
                  </div>
                  <div style={styles.quizModulesContainer}>
                    {renderModules(
                      thematicLiveModules,
                      expandedModuleThematicLive,
                      setExpandedModuleThematicLive,
                      "LIVE",
                    )}
                  </div>
                </div>

                {/* Practice Quiz Column */}
                <div style={{ flex: 1 }}>
                  <div style={styles.columnHeader}>
                    <span style={styles.columnHeaderText}>PRACTICE QUIZ</span>
                  </div>
                  <div style={styles.quizModulesContainer}>
                    {renderModules(
                      thematicPracticeModules,
                      expandedModuleThematicPractice,
                      setExpandedModuleThematicPractice,
                      "PRACTICE",
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* New Modern Popup Dialog */}
      {data.openPopUp && data.selectedQuiz && (
        <Dialog
          fullWidth
          maxWidth="sm"
          onClose={() =>
            setData((prev) => ({
              ...prev,
              selectedQuiz: null,
              openPopUp: false,
            }))
          }
          open={!!data.selectedQuiz}
          PaperProps={{
            style: {
              borderRadius: "12px",
              overflow: "hidden",
            },
          }}
        >
          {/* Header Section */}
          <div
            style={{
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              padding: "24px",
              color: "white",
              textAlign: "center",
              position: "relative",
            }}
          >
            <img
              onClick={() =>
                setData((prev) => ({
                  ...prev,
                  selectedQuiz: null,
                  openPopUp: false,
                }))
              }
              style={{
                cursor: "pointer",
                position: "absolute",
                top: "16px",
                right: "16px",
                background: "rgba(255,255,255,0.2)",
                borderRadius: "50%",
                padding: "4px",
              }}
              width="20"
              height="20"
              src="https://img.icons8.com/ios/50/ffffff/delete-sign--v1.png"
              alt="close"
            />

            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: "16px",
              }}
            >
              {data.selectedQuiz.quiz_type === 2 && (
                <img
                  src={"/images/quiz_popup.png"}
                  alt="Quiz Icon"
                  style={{
                    width: "60px",
                    height: "60px",
                    marginRight: "12px",
                    borderRadius: "8px",
                    backgroundColor: "white",
                    padding: "4px",
                  }}
                />
              )}
              <div>
                <h2
                  style={{
                    margin: 0,
                    fontSize: "24px",
                    fontWeight: "700",
                    marginBottom: "4px",
                  }}
                >
                  {data.selectedQuiz?.title}
                </h2>
                <p
                  style={{
                    margin: 0,
                    fontSize: "14px",
                    opacity: 0.9,
                  }}
                >
                  {data.selectedQuiz.quiz_type === 1
                    ? "Live Quiz"
                    : data.selectedQuiz.quiz_type === 2
                      ? "Practice Quiz"
                      : data.selectedQuiz.quiz_type === 3
                        ? "Thematic Live Quiz"
                        : "Practice Thematic Quiz"}
                </p>
              </div>
            </div>
          </div>

          <DialogContent style={{ padding: 0 }}>
            {/* Quiz Information Section */}
            <div style={{ padding: "24px" }}>
              {/* Info Rows */}
              <div style={styles.infoRow}>
                <span style={styles.infoLabel}>Module:</span>
                <span style={styles.infoValue}>
                  {data.selectedQuiz.category ||
                    data.selectedQuiz.subject ||
                    "General"}
                </span>
              </div>
              <div style={styles.infoRow}>
                <span style={styles.infoLabel}>Duration:</span>
                <span style={styles.infoValue}>
                  {formatDurationNew(
                    data.selectedQuiz.total_questions *
                      data.selectedQuiz.duration_per_question,
                  )}
                </span>
              </div>
              <div style={styles.infoRow}>
                <span style={styles.infoLabel}>Questions:</span>
                <span style={styles.infoValue}>
                  {data.selectedQuiz.total_questions}
                </span>
              </div>
              <div style={styles.infoRow}>
                <span style={styles.infoLabel}>Difficulty:</span>
                <span style={styles.infoValue}>
                  {data.selectedQuiz.difficulty_level || "Intermediate"}
                </span>
              </div>
              {data.selectedQuiz.quiz_type === 1 && (
                <>
                  <div style={styles.infoRow}>
                    <span style={styles.infoLabel}>Start Date:</span>
                    <span style={styles.infoValue}>
                      {formatDate(data.selectedQuiz.start_date)}
                    </span>
                  </div>
                  <div style={styles.infoRow}>
                    <span style={styles.infoLabel}>Registration Ends:</span>
                    <span style={styles.infoValue}>
                      {formatDate(data.selectedQuiz.registration_end_date)}
                    </span>
                  </div>
                </>
              )}
              {data.selectedQuiz.quiz_type === 1 ? (
                <>
                  {" "}
                  <div style={styles.infoRow}>
                    <span style={styles.infoLabel}>Class :</span>
                    <span style={styles.infoValue}>
                      {" "}
                      {data.selectedQuiz?.class_id
                        ? data.selectedQuiz.class_id
                            .map((e) => e.class_name)
                            .join(", ")
                        : "-"}{" "}
                    </span>
                  </div>
                  <div style={styles.infoRow}>
                    <span style={styles.infoLabel}>Subject:</span>
                    <span style={styles.infoValue}>
                      {" "}
                      {data.selectedQuiz?.subject_name || "-"}
                    </span>
                  </div>
                </>
              ) : data.selectedQuiz.quiz_type === 2 ? (
                <div style={styles.infoRow}>
                  <span style={styles.infoLabel}>Subject:</span>
                  <span style={styles.infoValue}>
                    {data.selectedQuiz?.subject_name || "-"}
                  </span>
                </div>
              ) : data.selectedQuiz.quiz_type === 3 ? (
                <>
                  <div style={styles.infoRow}>
                    <span style={styles.infoLabel}>Theme</span>
                    <span style={styles.infoValue}>
                      {getThemeDisplay(data.selectedQuiz?.theme)}
                    </span>
                  </div>
                  <div style={styles.infoRow}>
                    <span style={styles.infoLabel}>Group:</span>
                    <span style={styles.infoValue}>
                      {data.selectedQuiz.group_id[0]?.group_name}
                    </span>
                  </div>
                </>
              ) : data.selectedQuiz.quiz_type === 4 ? (
                <>
                  <div style={styles.infoRow}>
                    <span style={styles.infoLabel}>Theme : &nbsp;</span>
                    <span style={styles.infoValue}>
                      {getThemeDisplay(data.selectedQuiz?.theme)}
                    </span>
                  </div>
                </>
              ) : (
                ""
              )}

              <div style={styles.infoRow}>
                <span style={styles.infoLabel}>Status:</span>

                <span style={styles.infoValue}>
                  {data.selectedQuiz.quiz_type === 1 ||
                  data.selectedQuiz.quiz_type === 3 ? (
                    <span
                      style={{
                        background: "#fef3c7",
                        color: "#92400e",
                        padding: "4px 12px",
                        borderRadius: "4px",
                        fontSize: "12px",
                        fontWeight: "600",
                      }}
                    >
                      REGISTRATION OPEN
                    </span>
                  ) : (
                    <span
                      style={{
                        background: "#dbeafe",
                        color: "#1e40af",
                        padding: "4px 12px",
                        borderRadius: "4px",
                        fontSize: "12px",
                        fontWeight: "600",
                      }}
                    >
                      PRACTICE
                    </span>
                  )}
                </span>
              </div>

              {/* About Quiz Section */}
              {data.selectedQuiz.about_quiz && (
                <div style={{ marginTop: "20px" }}>
                  <h4
                    style={{
                      fontSize: "16px",
                      fontWeight: "600",
                      color: "#374151",
                      marginBottom: "8px",
                      borderBottom: "2px solid #e5e7eb",
                      paddingBottom: "4px",
                    }}
                  >
                    About Quiz
                  </h4>
                  <div
                    style={{
                      fontSize: "14px",
                      color: "#6b7280",
                      lineHeight: "1.5",
                    }}
                    dangerouslySetInnerHTML={{
                      __html: formatText(data.selectedQuiz.about_quiz),
                    }}
                  />
                </div>
              )}
              {/* Class Selection for Practice Quizzes */}
              {data.selectedQuiz?.quiz_type === 2 && showClassSelect && (
                <div style={{ marginTop: "20px" }}>
                  <label
                    style={{
                      display: "block",
                      marginBottom: "8px",
                      fontWeight: "600",
                      color: "#374151",
                      fontSize: "14px",
                    }}
                  >
                    Select Class
                  </label>
                  <select
                    style={{
                      width: "100%",
                      padding: "10px 12px",
                      border: "1px solid #d1d5db",
                      borderRadius: "6px",
                      fontSize: "14px",
                      backgroundColor: "white",
                      outline: "none",
                      transition: "all 0.2s",
                    }}
                    value={selectedClass}
                    onChange={(e) => setSelectedClass(e.target.value)}
                    onFocus={(e) => {
                      e.target.style.borderColor = "#3b82f6";
                      e.target.style.boxShadow =
                        "0 0 0 3px rgba(59, 130, 246, 0.1)";
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = "#d1d5db";
                      e.target.style.boxShadow = "none";
                    }}
                  >
                    <option value="">-- Choose your class --</option>
                    {classList.map((cls) => (
                      <option key={cls.id} value={cls.id}>
                        {cls.name || `Class ${cls.id}`}
                      </option>
                    ))}
                  </select>
                </div>
              )}
              {/* Group Selection for Thematic Practice Quizzes */}
              {data.selectedQuiz?.quiz_type === 4 && (
                <div style={{ marginTop: "20px" }}>
                  <label
                    style={{
                      display: "block",
                      marginBottom: "8px",
                      fontWeight: "600",
                      color: "#374151",
                      fontSize: "14px",
                    }}
                  >
                    Select Group
                  </label>
                  <select
                    style={{
                      width: "100%",
                      padding: "10px 12px",
                      border: "1px solid #d1d5db",
                      borderRadius: "6px",
                      fontSize: "14px",
                      backgroundColor: "white",
                      outline: "none",
                      transition: "all 0.2s",
                    }}
                    value={selectedGroup}
                    onChange={(e) => setSelectedGroup(e.target.value)}
                    onFocus={(e) => {
                      e.target.style.borderColor = "#3b82f6";
                      e.target.style.boxShadow =
                        "0 0 0 3px rgba(59, 130, 246, 0.1)";
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = "#d1d5db";
                      e.target.style.boxShadow = "none";
                    }}
                  >
                    <option value="">-- Choose Group --</option>
                    {(data.selectedQuiz?.group_id || []).map((g, index) => {
                      const id = typeof g === "object" ? g.group_id : g;
                      const name =
                        typeof g === "object"
                          ? g.group_name || `Group ${id}`
                          : `Group ${id}`;
                      const finalId = Array.isArray(id) ? id[0] : id;
                      return (
                        <option key={`${finalId}-${index}`} value={finalId}>
                          {name}
                        </option>
                      );
                    })}
                  </select>
                </div>
              )}
              {/* Terms & Conditions Section */}
              <div style={{ marginTop: "20px" }}>
                <h4
                  style={{
                    fontSize: "16px",
                    fontWeight: "600",
                    color: "#374151",
                    marginBottom: "8px",
                    borderBottom: "2px solid #e5e7eb",
                    paddingBottom: "4px",
                  }}
                >
                  {/* Terms & Conditionsdd */}
                  Instructions
                </h4>
                <div
                  style={{
                    fontSize: "12px",
                    color: "#6b7280",
                    lineHeight: "1.4",
                    maxHeight: "120px",
                    overflowY: "auto",
                    padding: "8px",
                    background: "#f9fafb",
                    borderRadius: "4px",
                  }}
                  dangerouslySetInnerHTML={{
                    __html:
                      data.selectedQuiz?.quiz_type === 1
                        ? convertTermsToHtml(
                            data.selectedQuiz.quiz_terms,
                            data.selectedQuiz,
                          )
                        : formatTerms(
                            data.selectedQuiz.quiz_terms,
                            data.selectedQuiz,
                          ),
                  }}
                />
              </div>
            </div>
          </DialogContent>

          {/* Action Buttons */}
          <DialogActions
            style={{
              padding: "16px 24px",
              borderTop: "1px solid #e5e7eb",
              justifyContent: "space-between",
            }}
          >
            <button
              style={{
                background: "#f3f4f6",
                color: "#6b7280",
                border: "none",
                borderRadius: "6px",
                padding: "10px 20px",
                fontWeight: "600",
                fontSize: "14px",
                cursor: "pointer",
                transition: "all 0.2s",
              }}
              onClick={() =>
                setData((prev) => ({
                  ...prev,
                  selectedQuiz: null,
                  openPopUp: false,
                }))
              }
              onMouseEnter={(e) => {
                e.currentTarget.style.background = "#e5e7eb";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = "#f3f4f6";
              }}
            >
              Cancel
            </button>

            <button
              style={{
                background: "#2563eb",
                color: "#ffffff",
                border: "none",
                borderRadius: "6px",
                padding: "10px 24px",
                fontWeight: "600",
                fontSize: "14px",
                cursor: "pointer",
                transition: "all 0.2s",
                minWidth: "140px",
              }}
              onClick={() => {
                // ✅ Type 1 → Live Quiz Registration
                if (
                  data.selectedQuiz?.quiz_type === 1 ||
                  data.selectedQuiz?.quiz_type === 3
                ) {
                  handleRegistration();
                  return;
                }
                // ✅ Type 2 → Practice Quiz (needs class)
                if (
                  data.selectedQuiz?.quiz_type === 2 &&
                  !data.selectedQuiz?.registration_start_date &&
                  !data.selectedQuiz?.registration_end_date &&
                  !data.selectedQuiz?.registration_type
                ) {
                  if (!selectedClass) {
                    alert("Please select a class before starting the quiz.");
                  } else {
                    handlePractice(
                      data.selectedQuiz.id,
                      data.selectedQuiz.quiz_type,
                      selectedClass,
                    );
                    setShowClassSelect(false);
                    setSelectedClass("");
                  }
                  return;
                }

                // ✅ Type 4 → Academic Thematic (Needs Group)
                if (
                  data.selectedQuiz?.quiz_type === 4 &&
                  !data.selectedQuiz?.registration_start_date &&
                  !data.selectedQuiz?.registration_end_date &&
                  !data.selectedQuiz?.registration_type
                ) {
                  if (!selectedGroup) {
                    alert("Please select a group before starting the quiz.");
                  } else {
                    handlePractice(
                      data.selectedQuiz.id,
                      data.selectedQuiz.quiz_type,
                      selectedGroup,
                    );
                    setSelectedGroup("");
                    setData((prev) => ({
                      ...prev,
                      selectedQuiz: null,
                      openPopUp: false,
                    }));
                  }
                  return;
                }

                // ✅ Type 3 → Thematic Live
                if (data.selectedQuiz?.quiz_type === 3) {
                  handlePractice(
                    data.selectedQuiz.id,
                    data.selectedQuiz.quiz_type,
                  );
                  return;
                }
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = "#1d4ed8";
                e.currentTarget.style.transform = "translateY(-1px)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = "#2563eb";
                e.currentTarget.style.transform = "translateY(0)";
              }}
              // disabled={
              //   (data.selectedQuiz?.quiz_type === 2 && !selectedClass) ||
              //   (data.selectedQuiz?.quiz_type === 4 && !selectedGroup)
              // }
            >
              {data.selectedQuiz?.quiz_type === 1 ||
              data.selectedQuiz?.quiz_type === 3
                ? "Confirm Registration"
                : "Play Now"}
            </button>
          </DialogActions>
        </Dialog>
      )}

      {/* Success Message Dialog */}
      <Dialog
        open={!!successMessage}
        onClose={() => setSuccessMessage("")}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>{successType}</DialogTitle>
        <DialogContent style={{ maxHeight: "200px", overflowY: "auto" }}>
          <Typography
            component="div"
            dangerouslySetInnerHTML={{ __html: successMessage }}
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setSuccessMessage("");
              if (
                successMessage !==
                "Registration for the quiz has closed. Please try again for the next quiz."
              ) {
                navigate("/quiz-dashboard/registeredQuizzes");
                window.location.reload();
              }
            }}
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>

      {/* Terms & Conditions Dialog */}
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        fullWidth
        style={{
          height: "100vh",
          overflowY: "auto",
          msOverflowStyle: "none",
          scrollbarWidth: "none",
        }}
        className="hide-scrollbar"
        maxWidth="lg"
      >
        <DialogContent
          style={{
            padding: 0,
            width: "100%",
            overflow: "hidden",
          }}
        >
          <img
            width="30"
            height="30"
            src="https://img.icons8.com/ios/50/delete-sign--v1.png"
            alt="delete-sign--v1"
            style={{
              float: "right",
              cursor: "pointer",
              padding: "10px",
            }}
            onClick={() => {
              setSelectedQuiz([]);
              setOpen(false);
            }}
          />
          <TermsAndConditions2 quizDetails={selectedQuiz} />
        </DialogContent>
      </Dialog>
    </div>
  );
}
